import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AccountSettingsComponent } from '../features/components/account-settings/account-settings.component';
import { BusinessVerificationComponent } from '../features/components/business-verification/business-verification.component';
import { BusinessSearchComponent } from '../features/components/business-search/business-search.component';
import { RedemptionReportComponent } from '../features/components/redemption-report/redemption-report.component';
import { UserLogoutComponent } from '../features/components/user-logout/user-logout.component';
import { UserProfileComponent } from '../features/components/user-profile/user-profile.component';
import { VoucherHomeComponent } from '../features/components/voucher-home/voucher-home.component';
import { VoucherLandingComponent } from '../features/components/voucher-landing/voucher-landing.component';
import { VoucherListComponent } from '../features/components/voucher-list/voucher-list.component';
import { VoucherRegistrationComponent } from '../features/components/voucher-registration/voucher-registration.component';
import { VoucherSetupComponent } from '../features/components/voucher-setup/voucher-setup.component';
import { GroupGuard } from './guards/group.guard';
import { preNavigationGuard } from './guards/pre-navigation.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { ReplaceW9Component } from '../features/components/replace-w9/replace-w9.component';
import { FaqComponent } from '../features/components/faq/faq.component';
import { LoginComponent } from '../features/components/login/login.component';
import { VerifyOtpComponent } from '../features/components/verify-otp/verify-otp.component';
import { AuthGuard } from './guards/auth.guard';
import { ContactusComponent } from '../features/components/contactus/contact-us.component';
import { W9BusinessVerificationComponent } from '../features/components/w9-business-verification/w9-business-verification.component';

export const routes: Routes = [{
  path: '',
  component: VoucherLandingComponent
},
{
  path: 'register',
  component: VoucherRegistrationComponent
}, {
  path: 'home',
  component: VoucherHomeComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1','2','3'] }
}, {
  path: 'voucher-list',
  component: VoucherListComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1','2','3'] }
},
{ path: 'voucher-list/:id', 
  component: VoucherListComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1'] }
},
{
  path: 'logout',
  component: UserLogoutComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1','2','3'] }
},
{
  path: 'account-settings',
  component: AccountSettingsComponent,
  canActivate: [AuthGuard, GroupGuard],
  canDeactivate: [unsavedChangesGuard],
  data: { roles: ['1','2','3'] }
},
{
  path: 'account-settings/:id',
  component: AccountSettingsComponent,
  canActivate: [AuthGuard, GroupGuard],
  canDeactivate: [unsavedChangesGuard],
  data: { roles: ['1'] }
},
{
  path: 'user-profile/:id',
  component: UserProfileComponent,
  canActivate: [AuthGuard, GroupGuard],
  canDeactivate: [unsavedChangesGuard],
  data: { roles: ['1','2','3'] }
},
{
  path: 'user-profile',
  component: UserProfileComponent,
  canActivate: [AuthGuard, GroupGuard],
  canDeactivate: [unsavedChangesGuard],
  data: { roles: ['1','2','3'] }
}, {
  path: 'voucher-setup',
  component: VoucherSetupComponent,
  canActivate: [preNavigationGuard, AuthGuard, GroupGuard],
  canDeactivate: [unsavedChangesGuard],
  data: { roles: ['1','2','3'] }
}, {
  path: 'redemption-report',
  component: RedemptionReportComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1'] }
}, {
  path: 'business-review',
  component: BusinessVerificationComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1'] }
}, {
  path: 'business-search',
  component: BusinessSearchComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1'] }
},{
  path: 'replace-w9',
  component: ReplaceW9Component,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1','2'] }
},{
  path: 'w9-business-verification',
  component: W9BusinessVerificationComponent,
  canActivate: [AuthGuard, GroupGuard],
  data: { roles: ['1','2','3'] }
},{
  path: 'faq',
  component: FaqComponent
},{
  path: 'contact-us',
  component: ContactusComponent
},
{
  path: 'login',
  component: LoginComponent  
},
{
  path: 'verify-otp',
  component: VerifyOtpComponent  
},{
  path: 'paydayperx-register',
  component: VoucherRegistrationComponent
},{
  path: 'nsc-register',
  component: VoucherRegistrationComponent
}
];
